import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of, ReplaySubject } from 'rxjs';
import { share, switchMap } from 'rxjs/operators';
import { ConfigService } from 'src/app/core/services/config.service';
import { DictionaryDataItem } from '../model/DictionaryDataItem';


@Injectable({
  providedIn: 'root'
})
export class CarDictionaryService {


  localizationCode: string;

  constructor(private http: HttpClient,
              private configService: ConfigService
  ) { }

  public getCarBrands(pattern:string ): Observable<DictionaryDataItem[]> {
    if(!pattern){
      return of<DictionaryDataItem[]>([]);
    }

      return this.http.get<DictionaryDataItem[]>(
        this.configService.PortalWebApiUrl + 'carDictionary/brand/' + pattern)
        .pipe(
          switchMap( r => {  return of<DictionaryDataItem[]>(r); } ),
          share({ connector: () => new ReplaySubject(1)}),
        );
  }

  public getCarModels(carBrand:string, pattern:string ): Observable<DictionaryDataItem[]> {
    
    if(!carBrand || !pattern){
      return of<DictionaryDataItem[]>([]);
    }

      return this.http.get<DictionaryDataItem[]>(
        this.configService.PortalWebApiUrl + 'carDictionary/model/' + carBrand + '/' + pattern)
        .pipe(
          switchMap( r => {  return of<DictionaryDataItem[]>(r); } ),
          share({ connector: () => new ReplaySubject(1)})
        );
  }

  
  public addCarBrand(data: DictionaryDataItem): Observable<number> {
    return this.http.post<number>(
      this.configService.PortalWebApiUrl + 'carDictionary/addCarBrand', data);
  }

  public addCarModel(brandName:string, data: DictionaryDataItem): Observable<number> {
    return this.http.post<number>(
      this.configService.PortalWebApiUrl + 'carDictionary/addCarModel/' + brandName, data);
  }
}